// extracted by mini-css-extract-plugin
module.exports = {"paymentScheduleTitleWrapper":"style_paymentScheduleTitleWrapper__SJBH2","Unicorn_paymentScheduleTitleWrapperMargin":"style_Unicorn_paymentScheduleTitleWrapperMargin__MNoUB"};